import { Button, Typography } from '@mui/material';
import { FormCheckbox, FormInputGroup, FormSection } from 'components/form';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
    BulkEditOption,
    defaultDeviceSettingsValues,
} from '../../BulkEditDevicesModal';
import styles from './Selection.module.scss';

export function BulkEditDevicesSelection() {
    const { watch, setValue, reset } = useFormContext();

    const alertFields = watch(['tcov', 'thresh1', 'thresh2']);

    const allFields = watch();

    const enableThresholdAlerts = alertFields.filter(
        (af: BulkEditOption<any>) => af.enabled
    ).length;

    useEffect(() => {
        if (enableThresholdAlerts) {
            setValue('thresh_enabled.enabled', true);
        } else {
            setValue('thresh_enabled.enabled', false);
        }
    }, [enableThresholdAlerts, setValue]);

    const handleResetField = (field: string) => {
        const defaultValue =
            defaultDeviceSettingsValues[
                field as keyof typeof defaultDeviceSettingsValues
            ]?.value;

        setValue(`${field}.value`, defaultValue);
    };

    const handleToggleAll = (toggle: boolean) => {
        if (toggle === false) {
            return reset();
        }
        return Object.keys(allFields).forEach((f) => {
            setValue(`${f}.enabled`, toggle);
        });
    };

    return (
        <FormSection title="Selection" condensed>
            <Typography variant="h6">Select Settings to change</Typography>
            <Typography variant="subtitle2">Alert Settings</Typography>
            <FormInputGroup>
                <FormCheckbox
                    field="users.enabled"
                    label="Subscribers"
                    onChange={() => handleResetField('users')}
                />
            </FormInputGroup>
            <FormInputGroup>
                <FormCheckbox
                    field="tcov.enabled"
                    label="Change of Tank Level Since Last Transmission (%)"
                    onChange={() => handleResetField('tcov')}
                />
            </FormInputGroup>
            <FormInputGroup>
                <FormCheckbox
                    field="thresh1.enabled"
                    label="Warning Threshold (%)"
                    onChange={() => handleResetField('thresh1')}
                />
            </FormInputGroup>
            <FormInputGroup>
                <FormCheckbox
                    field="thresh2.enabled"
                    label="Critical Threshold (%)"
                    onChange={() => handleResetField('thresh2')}
                />
            </FormInputGroup>
            <Typography variant="subtitle2">Device Settings</Typography>
            <FormInputGroup>
                <FormCheckbox
                    field="group.enabled"
                    label="Group"
                    onChange={() => handleResetField('group')}
                />
            </FormInputGroup>
            <FormInputGroup>
                <FormCheckbox
                    field="ftt.enabled"
                    label="Transmission Time"
                    onChange={() => handleResetField('ftt')}
                />
            </FormInputGroup>
            <Typography variant="subtitle2">
                Reading & Reporting Settings
            </Typography>
            <FormInputGroup>
                <FormCheckbox
                    field="r_int.enabled"
                    label="Reading Interval"
                    onChange={() => handleResetField('r_int')}
                />
            </FormInputGroup>
            <FormInputGroup>
                <FormCheckbox
                    field="t_int.enabled"
                    label="Reporting Interval"
                    onChange={() => handleResetField('t_int')}
                />
            </FormInputGroup>
            <div className={styles.buttonContainer}>
                <Button
                    variant="contained"
                    onClick={() => handleToggleAll(true)}
                >
                    Enable All
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleToggleAll(false)}
                >
                    Disable All
                </Button>
            </div>
        </FormSection>
    );
}
